import posthog from "posthog-js";

let capturedPathname: string | null = null;

export function capturePageview(pathname: string) {
    if (pathname === capturedPathname) return;
    capturedPathname = pathname;
    posthog.capture("$pageview");
}
